import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import {
    EProductTypeConfigTitle,
    EProductTypeInternalName,
    type IProductTypeConfigDto,
    type IProductTypeConfigModel,
    type IProductTypeDto,
    type IProductTypeModel,
    type TProductTypeInternalNameDto
} from "@/3514/types"

function getProductTypeInternalNameEnumFromType(type: TProductTypeInternalNameDto): EProductTypeInternalName {
    switch (type) {
        case null:
            return null
        case "wiser-demo":
            return EProductTypeInternalName.WiserDemo
        case "spot-coaching":
            return EProductTypeInternalName.SpotCoaching
        case "executive-coaching":
            return EProductTypeInternalName.ExecutiveCoaching
        case "leadership-coaching":
            return EProductTypeInternalName.LeadershipCoaching
        case "wiser":
        default:
            return EProductTypeInternalName.Wiser
    }
}

function productTypeAdapter(dto: IProductTypeDto): IProductTypeModel {
    return isEmpty(dto)
        ? null
        : {
              configs: isEmpty(dto.configs)
                  ? []
                  : map<IProductTypeConfigDto, IProductTypeConfigModel>(
                        dto.configs,
                        (c: IProductTypeConfigDto): IProductTypeConfigModel => ({
                            isActive: c.is_active,
                            title: ((): EProductTypeConfigTitle => {
                                switch (c.title) {
                                    case "show-coaching-plan":
                                        return EProductTypeConfigTitle.ShowCoachingPlan
                                    case "show-post-session-popup":
                                        return EProductTypeConfigTitle.ShowPostSessionPopup
                                    case "allow-modules":
                                        return EProductTypeConfigTitle.AllowModules
                                    case null:
                                    default:
                                        return null
                                }
                            })()
                        })
                    ),
              logo: dto.logo,
              coachingSessionsPageName: dto.session_page_name_data,
              coachingSessionsPageNameInPreferredLang: dto.session_page_name_pref_lang,
              supportEmail: dto.support_email,
              supportTeamName: dto.support_team_name_data,
              supportTeamNameInPreferredLang: dto.support_team_name_pref_lang,
              productTypeTitle: dto.title_data,
              productTypeTitleInPreferredLang: dto.title_pref_lang,
              internalName: getProductTypeInternalNameEnumFromType(dto.internal_name)
          }
}

export { getProductTypeInternalNameEnumFromType, productTypeAdapter }
